exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3_E8L56zgiddSg8mlgyYZ7{padding:10px}._3_E8L56zgiddSg8mlgyYZ7 ._3Pf6retSOZHno5V2T1492p{font-weight:bold;font-size:14px;line-height:18px;margin-bottom:5px}._3_E8L56zgiddSg8mlgyYZ7 ._5r2gTiWkUpTF4KKut5FkT{font-size:13px;line-height:17px;padding-bottom:10px}._3_E8L56zgiddSg8mlgyYZ7 a._3X-2EYPnEQVOnqci92caGa{text-align:left;font-weight:500;font-size:13px}\n", ""]);

// Exports
exports.locals = {
	"LocaleSwitcherBump": "_3_E8L56zgiddSg8mlgyYZ7",
	"header": "_3Pf6retSOZHno5V2T1492p",
	"body": "_5r2gTiWkUpTF4KKut5FkT",
	"dismiss": "_3X-2EYPnEQVOnqci92caGa"
};